module.exports = __webpack_public_path__ + "static/img/claim@2x.aa806ac6.png";